<template>
  <!-- 公司简介区块：介绍公司基本信息和核心价值 -->
  <section id="about" class="about-section">
    <div class="about-container">
      <!-- 区块标题：左对齐，带装饰线 -->
      <div class="section-header">
        <h2 class="section-title">公司简介</h2>
        <div class="title-underline"></div>
      </div>
      
      <!-- 图文内容区：电脑端左右并排，移动端上下排列 -->
      <div class="about-content">
        <!-- 左侧：文字介绍卡片 -->
        <div class="about-text-card">
          <div class="about-text">
            <p class="intro-text">
              <strong>匠心致诚（武汉）技术服务有限公司</strong>
              是一家专门提供<strong class="highlight">数控加工设备管理保障服务</strong>及<strong class="highlight">设备工程服务完整解决方案</strong>的专业技术型公司。
            </p>
            <p>
              公司秉承<strong class="highlight">“专业、高效、创新”</strong>的经营宗旨，从专业从事数控机床维护、维修、改造、搬迁等工作的团队，
              逐步发展为以承接设备管理保障外包服务模式为主，向客户提供设备保障、设备管理咨询、技术支持、备件供应等完整设备工程服务的技术服务企业。
            </p>

            <div class="biz-list">
              <div class="biz-title">主营业务</div>
              <ul>
                <li>设备针对性维修服务</li>
                <li>设备专项维修服务</li>
                <li>设备集中深度保养服务（二级维护）</li>
                <li>设备年度保障服务</li>
                <li>设备状态检测服务（三级维护）</li>
                <li>设备搬迁一条龙服务</li>
                <li>设备改造服务</li>
                <li>客户定制服务</li>
              </ul>
            </div>
          </div>
        </div>
        
        <!-- 右侧：图片展示卡片 -->
        <div class="about-image-card">
          <div class="about-image">
            <ZoomableImage
              :src="require('@/assets/images/gallery/field-diagnosis-1.jpg')"
              alt="现场服务与数控设备保障"
              fit="cover"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ZoomableImage from './ZoomableImage.vue';

export default {
  name: 'AboutSection',
  components: {
    ZoomableImage
  }
};
</script>

<style scoped>
/* ============================================================
   公司简介区块容器样式
   作用：定义整个区块的背景和内边距
   影响：区块上下有80px内边距，与上下内容保持距离
   ============================================================ */
.about-section {
  background: #ffffff;
  padding: 80px 0;
}

/* 内容容器：电脑端最大宽度1200px，水平居中 */
.about-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ============================================================
   区块标题样式（左对齐）
   作用：显示"公司简介"标题，左侧有装饰线
   影响：标题靠左对齐，区别于之前的居中标题风格
   ============================================================ */
.section-header {
  margin-bottom: 48px;
}

.section-title {
  font-size: 2rem;
  font-weight: bold;
  color: #1a1a2e;
  margin-bottom: 12px;
}

/* 标题下方的装饰线：蓝色短横线，增强视觉层次 */
.title-underline {
  width: 60px;
  height: 3px;
  background: #1976d2;
  border-radius: 2px;
}

/* ============================================================
   图文内容区样式
   作用：电脑端使用Grid双栏布局，左右并排
   影响：文字卡片和图片卡片各占一半宽度
   ============================================================ */
.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}

/* 文字卡片样式：白色背景，圆角阴影 */
.about-text-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  padding: 32px;
}

/* 文字段落样式：行高适中，颜色柔和 */
.about-text p {
  font-size: 1rem;
  line-height: 1.8;
  color: #4a4a4a;
  margin-bottom: 20px;
}

/* 首段文字：字体稍大，突出公司名称 */
.intro-text {
  font-size: 1.05rem;
  color: #333;
}

/* 高亮关键词：品牌蓝色加粗 */
.highlight {
  color: #1976d2;
  font-weight: 600;
}

.biz-list {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px dashed #e6e6e6;
}

.biz-title {
  font-size: 1rem;
  font-weight: 800;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.biz-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 18px;
}

.biz-list li {
  position: relative;
  padding-left: 14px;
  font-size: 0.98rem;
  color: #444;
  line-height: 1.6;
}

.biz-list li::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #1976d2;
  position: absolute;
  left: 0;
  top: 10px;
}

/* 图片卡片样式 */
.about-image-card {
  background: #f5f7fa;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
}

/* 图片样式：填满容器，保持比例 */
.about-image {
  width: 100%;
  height: 420px;
}

/* ============================================================
   响应式样式：手机端（宽度小于768px）
   作用：改为上下排列，文字在上图片在下
   影响：移动端显示为标题-图片-文字的顺序
   ============================================================ */
@media (max-width: 768px) {
  .about-section {
    padding: 50px 0;
  }
  
  .about-container {
    padding: 0 20px;
  }
  
  .section-title {
    font-size: 1.6rem;
  }
  
  /* 改为单列布局，图片在文字上方 */
  .about-content {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .about-text-card {
    order: 2;  /* 文字卡片放在图片下方 */
    padding: 24px;
  }
  
  .about-image-card {
    order: 1;  /* 图片卡片放在上方 */
  }

  .about-image {
    height: 260px;
  }
  
  .about-text p {
    font-size: 0.95rem;
  }

  .biz-list ul {
    grid-template-columns: 1fr;
  }
}
</style>